/**
 * Records Data Management Composable
 * Single Responsibility: Manages records/discovery data state
 */
import { ref, computed } from '@vue/composition-api';

export function useRecordsData() {
  // State
  const discoveries = ref([]);
  const selectedType = ref('all');

  /**
   * Initialize records data from API response
   * @param {Object} data - API response data
   */
  const initRecordsData = (data) => {
    discoveries.value = data.discoveries || [];
    return data;
  };

  /**
   * Set selected type filter
   * @param {string} type - Filter type
   */
  const setSelectedType = (type) => {
    selectedType.value = type;
  };

  /**
   * Filter discoveries by type
   * @param {string} type - Type to filter by
   * @returns {Array} Filtered discoveries
   */
  const getDiscoveriesByType = (type) => {
    if (type === 'all') return discoveries.value;
    return discoveries.value.filter(discovery => discovery.type === type);
  };

  // Computed properties
  const hasDiscoveries = computed(() => discoveries.value.length > 0);
  const filteredDiscoveries = computed(() => getDiscoveriesByType(selectedType.value));

  return {
    // State
    discoveries,
    selectedType,
    
    // Computed
    hasDiscoveries,
    filteredDiscoveries,
    
    // Methods
    initRecordsData,
    setSelectedType,
    getDiscoveriesByType
  };
}